import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { SystemSetting } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "SystemSetting";
export const SystemSettingService = {
	endpoint,
	getAll: async () => await Service.getAll(endpoint),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	passwordComplexityRules: async () => await FetchInterceptor(`${process.env.REACT_APP_SERVER_APIURL}/${endpoint}/PasswordComplexityRules`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	updateSingleById: async (id: number, data: SystemSetting) => await Service.updateSingleById(endpoint, id, data)
}